module.exports = __webpack_public_path__ + "img/eC-goods-details1-1.e87a505a.jpg";